import { handleGetProfileAction } from "@/actions/user.action";
import { useQuery } from "@tanstack/react-query";

const useUser = () => {
  return useQuery({
    queryKey: ["my-profile"],
    queryFn: handleGetProfileAction,
    staleTime: 5 * 60 * 1000,
    select: (res) => (res?.success && "user" in res ? res.user : null),
  });
};

export { useUser };
